module.exports = __webpack_public_path__ + "static-portal/img/2-1.a2a7bbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/2-1.jpg
// module id = +rKc
// module chunks = 4